<script setup lang="ts">
  import { computed, ref } from "vue";
  import { Partner } from "@/data/actions-query";
  import GenericPartnerPanel from "./generic-partner-panel.vue";
  import Avatar from "primevue/avatar";

  const collapsed = ref(true);

  const { partner } = defineProps<{
    partner: Partner;
  }>();
  const contactPerson = computed(() => {
    if (partner.accounts?.length) {
      return partner.accounts.at(-1);
    } else if (partner.invites?.length) {
      return partner.invites.at(-1);
    } else {
      return null;
    }
  });
</script>
<template>
  <GenericPartnerPanel :partner="partner" v-model:collapsed="collapsed" :edit_route="{ name: 'admin-partners-edit', params: { id: partner.id } }">
    <template #header>
      <div class="flex items-center gap-2 overflow-hidden" @click="collapsed = !collapsed">
        <Avatar
          :image="`https://api.dicebear.com/9.x/initials/svg?seed=${contactPerson?.first_name ? contactPerson.first_name.charAt(0) : ''}${
            contactPerson?.last_name ? contactPerson.last_name.charAt(0) : ''
          }`"
          shape="circle"
        />
        <div class="flex flex-col gap-1 p-2">
          <span class="font-bold">{{ partner.company_name }}</span>
          <span class="text-12 text-gray-500 truncate">{{ contactPerson?.email }} · {{ contactPerson?.phone }}</span>
        </div>
      </div>
    </template>
    <div class="flex flex-col gap-2">
      <div class="flex flex-col gap-1">
        <div class="text-gray-500 text-12">Bedrijf</div>
        <div class="text-14">
          {{ partner.company_name }}
        </div>
      </div>
      <div v-if="partner.services?.length" class="flex flex-col gap-1">
        <div class="text-gray-500 text-12">Diensten</div>
        <div class="text-14">
          {{ partner.services.map((service) => service.title).join(", ") }}
        </div>
      </div>
      <div v-if="partner.offices?.length" class="flex flex-col gap-1">
        <div class="text-gray-500 text-12">Actieve kantoren</div>
        <div class="text-14">
          {{ partner.offices.map((office) => office.name).join(", ") }}
        </div>
      </div>
    </div>
  </GenericPartnerPanel>
</template>
